import enMessages from './en';
import esMessages from './es';
import deMessages from './de';
import thMessages from './th';
import laMessages from './lo';

export const messages = { 'lo-LA': laMessages, 'th-TH': thMessages, 'en-US': enMessages, 'es-ES': esMessages, 'de-DE': deMessages };
